import React, { memo } from 'react';
import { Gamepad2 } from 'lucide-react';

interface GamesSectionProps {
  banners: {
    bgmiBanner: string;
    ffBanner: string;
  };
  onGameSelect: (game: string) => void;
}

const GamesSection = memo(({ banners, onGameSelect }: GamesSectionProps) => {
  const games = [
    { 
      id: 'BGMI', 
      name: 'BGMI', 
      banner: banners.bgmiBanner,
      description: 'Squad • Solo • Scrims',
      color: 'text-blue-400',
      badge: 'Active'
    },
    { 
      id: 'FFMAX', 
      name: 'FREE FIRE MAX', 
      banner: banners.ffBanner,
      description: 'Daily Tournaments',
      color: 'text-orange-400',
      badge: 'Popular'
    }
  ];

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-white font-rajdhani font-bold text-xl flex items-center gap-2">
          <Gamepad2 className="w-5 h-5 text-purple-400" />
          Battle Arena
        </h2>
        <div className="w-12 h-0.5 bg-gradient-to-r from-purple-500 to-blue-500" />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {games.map((game) => (
          <button
            key={game.id}
            onClick={() => onGameSelect(game.id)}
            className="group relative h-48 rounded-2xl overflow-hidden cursor-pointer hover:scale-102 transition-transform duration-300"
          >
            <img
              src={game.banner}
              alt={game.name}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              loading="lazy"
              decoding="async"
              onError={(e) => {
                (e.target as HTMLImageElement).src = 'https://images.unsplash.com/photo-1542751371-adc38448a05e?w=800&h=400&fit=crop';
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent">
              <div className="absolute bottom-4 left-4">
                <h3 className="text-white font-rajdhani font-bold text-2xl">{game.name}</h3>
                <p className={`${game.color} text-xs`}>{game.description}</p>
                <div className="flex items-center gap-2 mt-2">
                  <span className={`px-2 py-0.5 bg-${game.id === 'BGMI' ? 'blue' : 'orange'}-500/20 rounded-full ${game.color} text-xs`}>
                    {game.badge}
                  </span>
                  <span className="px-2 py-0.5 bg-green-500/20 rounded-full text-green-400 text-xs">
                    Live
                  </span>
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
});

GamesSection.displayName = 'GamesSection';
export default GamesSection;